import { render, staticRenderFns } from "./Vehiculo.vue?vue&type=template&id=6a305105"
import script from "./Vehiculo.vue?vue&type=script&lang=js"
export * from "./Vehiculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports